class UTHeader {
  constructor() {
    this.elm = document.querySelector('[data-role="ut-header"]');
    this.opener = document.querySelector('[data-role="ut-header-opener"]');
    this.closer = document.querySelector('[data-role="ut-header-closer"]');
    this.navWrap = document.querySelector('[data-role="ut-header-nav-wrap"]');
    this.navItems = document.querySelectorAll('[data-role="ut-header-nav-item"]');

    if (!this.elm || !this.opener || !this.closer || !this.navWrap || !this.navItems.length) return;

    this.opener.addEventListener('click', () => this.openerHandler());
    this.closer.addEventListener('click', () => this.closerhandler());

    this.navItems.forEach((item) => {
      item.addEventListener('click', () => {
        this.close();
      });
    });
  }

  // handler
  openerHandler() {
    this.open();
  }

  closerhandler() {
    this.close();
  }

  // methods
  open() {
    this.elm.classList.add('--is-open');
    this.opener.classList.add('d-none');
    this.closer.classList.remove('d-none');
    this.navWrap.classList.remove('d-none');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.elm.classList.remove('--is-open');
    this.opener.classList.remove('d-none');
    this.closer.classList.add('d-none');
    this.navWrap.classList.add('d-none');
    document.body.style.overflow = 'auto';
  }
}

export default UTHeader;
